<template>
  <form class="contact-form" @submit.prevent="submit">
    <label
      >Nome<input v-model.trim="form.nome" name="nome" autocomplete="name" required maxlength="150"
    /></label>
    <label
      >Empresa<input
        v-model.trim="details.empresa"
        name="empresa"
        autocomplete="organization"
        maxlength="150"
    /></label>
    <label
      >Cargo<input
        v-model.trim="details.cargo"
        name="cargo"
        autocomplete="organization-title"
        maxlength="100"
    /></label>
    <label
      >Telefone<input
        v-model.trim="form.whatsapp"
        name="whatsapp"
        type="tel"
        autocomplete="tel"
        required
        maxlength="30"
    /></label>
    <label
      >E-mail<input
        v-model.trim="form.email"
        name="email"
        type="email"
        autocomplete="email"
        required
        maxlength="200"
    /></label>
    <label
      >Cidade / Estado<input
        v-model.trim="details.cidadeEstado"
        name="cidadeEstado"
        autocomplete="address-level2"
        maxlength="150"
    /></label>
    <label class="full"
      >Qual solução você procura?<select v-model="form.interesse" name="interesse">
        <option value="">Selecione uma solução</option>
        <option v-for="item in solutions" :key="itemId(item)" :value="text(item)">
          {{ text(item) }}
        </option>
      </select></label
    >
    <label class="full"
      >Mensagem<textarea
        v-model.trim="form.mensagem"
        name="mensagem"
        rows="6"
        maxlength="4000"
      ></textarea>
    </label>
    <button class="btn btn-dark full" type="submit" :disabled="sending">
      {{ sending ? 'Enviando…' : 'Enviar mensagem' }}
    </button>
    <p v-if="message" role="status" class="full">{{ message }}</p>
  </form>
</template>
<script>
import { sendContact, contentValue, plainText, itemId } from '@/services/contentApi';
const emptyDetails = () => ({ empresa: '', cargo: '', cidadeEstado: '' });
const empty = () => ({ nome: '', email: '', whatsapp: '', interesse: '', mensagem: '' });
export default {
  name: 'ContactForm',
  props: { solutions: { type: Array, default: () => [] } },
  data: () => ({ form: empty(), details: emptyDetails(), sending: false, message: '' }),
  methods: {
    itemId,
    text(item) {
      return plainText(contentValue(item, 'iti_nome'));
    },
    async submit() {
      if (this.sending) return;
      this.sending = true;
      this.message = '';
      try {
        await sendContact({ ...this.form, ...this.details });
        this.message = 'Mensagem enviada com sucesso.';
        this.form = empty();
        this.details = emptyDetails();
      } catch {
        this.message = 'Não foi possível enviar a mensagem. Tente novamente.';
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
